app.service('toCartView', function () {
	return {
		init: function () { }
	};
});
